import Vue from 'vue';
import Router from 'vue-router';

//Web Routes
import chat_content from '../components/chat_content';
import MeshLogout from '../components/meshLogout.vue';
const chatgrp_list = () => import('../components/chatgrp_list.vue');
const chatgrp_add = () => import('../components/chatgrp_add.vue');
const chatgrp_details = () => import('../components/chatgrp_details');
const chatgrp_edit = () => import('../components/chatgrp_edit');
const chatmsg = () => import('../components/chatmsg.vue');
const relevant = () => import('../components/relevant');
const pinned_message_list = () => import('../components/pinned_message_list');
const mention_message_user = () => import('../components/mention_message_user.vue');

const invite = () => import('../components/invite.vue');

const login = () => import('../components/login');
const register = () => import('../components/register');
const activate = () => import('../components/activate');
const quick_user_profile = () => import('../components/quick_user_profile');
const user_profile = () => import('../components/user_profile');
const participant_profile = () => import('../components/participant_profile');

const microapp_jobs = () => import('../components/microapp_jobs');
const microapp_events = () => import('../components/microapp_events');
const microapp_buzz = () => import('../components/microapp_buzz');
const boards = () => import('../components/boards/boards');
const board_home = () => import('../components/boards/board_home');

const media = () => import('../components/media');

const home = () => import('../components/home.vue');
const meshGateway = () => import('../components/meshGateway.vue');

const video = () => import('../components/video');
const PageNotFound = () => import('../components/page_not_found');
const warnings = () => import('../components/warnings');


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/gateway/:encrypted_user_id',
      name: 'gateway',
      component: meshGateway,
      meta: {
        requiresVisitors:true
      }
    },
    {
      path: '/video',
      name: 'video',
      component: video,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        requiresVisitors:true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        requiresVisitors:true
      }
    },
    {
      path: '/activate',
      name: 'activate',
      component: activate,
      meta: {
        requiresVisitors:true
      }
    },
    {
      path: '/',
      name: 'chat_content_default',
      component: chatgrp_list,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/chat',
      name: 'chat_content',
      component: chatgrp_list,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: invite,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/relevant',
      name: 'relevant',
      component: relevant,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/deeplink_to_board',
      name: 'board_deeplink',
      component: boards,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/deeplink_to_message',
      name: 'chat_message_deeplink',
      component: chatmsg,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/share_content',
      name: 'chat',
      component: chat_content,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/chat_message',
      name: 'chat_message',
      component: chatmsg,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/chatgrp_details',
      name: 'chatgrp_details',
      component: chatgrp_details,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/chatgrp_edit',
      name: 'chatgrp_edit',
      component: chatgrp_edit,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/chatgrp_add_invite/',
      name: 'chatgrp_add_invite',
      component: chatgrp_list,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/chatgrp_add/',
      name: 'chatgrp_add',
      component: chatgrp_add,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/quick-profile',
      name: 'quick_user_profile',
      component: quick_user_profile,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: user_profile,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/participant-profile',
      name: 'participant_profile',
      component: participant_profile,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/pinned_message',
      name: 'pinned_message',
      component: pinned_message_list,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/mention_message_user',
      name: 'mention_message_user',
      component: mention_message_user,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/buzz',
      name: 'microapp_buzz',
      component: microapp_buzz,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/events',
      name: 'microapp_events',
      component: microapp_events,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/gigs',
      name: 'microapp_jobs',
      component: microapp_jobs,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      }
    },
    {
      path: '/boards/:board_id?',
      name: 'boards',
      component: boards,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/board_home',
      name: 'board_home',
      component: board_home,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: login,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/mesh_logout',
      name: 'meshLogout',
      component: MeshLogout,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/media',
      name: 'media',
      component: media,
      meta: {
        requiresAuth:true,
        isDialogPage:true
      },      
    },
    {
      path: '/warnings',
      name: 'warnings',
      component: warnings,
      meta: {
        requiresAuth:true,
        isDialogPage:false
      },      
    },
    // and finally the default route, when none of the above matches:
    { path: "*", component: PageNotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
    //When user comes back to the Home Page, the page scrolls down automatically. 
    //This happens because the page has not reloaded and the height settings of the previous screen are applicable, which causes this issues
    if (savedPosition) {
      return savedPosition
    }else if (to.hash) {
      return {
        selector: to.hash
      };
    }else {
      return { x: 0, y: 0 }
    }
  }
})
